import { createEntityAdapter } from '@reduxjs/toolkit';
import { idComparator, stringPropertyComparator } from '@utils/common.utils';

import { NormalizedDrone, StrategicDrone } from '@/types/utm/drone.types';
import { NormalizedFleet } from '@/types/utm/fleet.type';
import { FlyZone } from '@/types/utm/flyZone.types';
import { Pilot } from '@/types/utm/pilot.types';
import { NormalizedFlyRoute, NormalizedFlySection } from '@/types/utm/route.types';

const codeComparator = stringPropertyComparator('code');

export const pilotsAdapter = createEntityAdapter<Pilot, string>({
  selectId: (pilot) => pilot.code,
  sortComparer: codeComparator,
});

export const dronesAdapter = createEntityAdapter<NormalizedDrone, string>({
  selectId: (drone) => drone.code,
  sortComparer: codeComparator,
});

export const fleetsAdapter = createEntityAdapter<NormalizedFleet, string>({
  selectId: (fleet) => fleet.code,
  sortComparer: codeComparator,
});

export const strategicDronesAdapter = createEntityAdapter<StrategicDrone, number>({
  selectId: (drone) => drone.id,
  sortComparer: idComparator,
});

export const flyZonesAdapter = createEntityAdapter<FlyZone, string>({
  selectId: (flyZone) => flyZone.code,
  sortComparer: codeComparator,
});

export const flySectionsAdapter = createEntityAdapter<NormalizedFlySection, string>({
  selectId: (flySection) => flySection.code,
  sortComparer: codeComparator,
});

export const flyRoutesAdapter = createEntityAdapter<NormalizedFlyRoute, string>({
  selectId: (flyRoute) => flyRoute.code,
  sortComparer: codeComparator,
});
